import { isJSON } from "./index";
export default {
  setStorage(key, value) {
    if (typeof value === "object") {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  },
  getStorage(key) {
    let res = localStorage.getItem(key);
    if (isJSON(res)) {
      return JSON.parse(res);
    }
    return res;
  },
  localSession() {
    localStorage.clear();
  },
  setSession(key, value) {
    if (typeof value === "object") {
      sessionStorage.setItem(key, JSON.stringify(value));
    } else {
      sessionStorage.setItem(key, value);
    }
  },
  getSession(key) {
    let res = sessionStorage.getItem(key);
    if (isJSON(res)) {
      return JSON.parse(res);
    }
    return res;
  },
  clearSession() {
    sessionStorage.clear();
  },
};
